import React from 'react';

import styles from './styles.module.css';

const Info = ({children}) => <div className={styles.info}>{children}</div>;

export default Info;
